<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on }">
      <div v-on="on" class="lang-selector">
        <span>{{ selectedLanguage.code }}</span>
      </div>
    </template>
    <v-list class="language--menu-color">
      <v-list-tile v-for="(language, index) in languages" :key="index" @click="selectLanguage(language)">
        <v-list-tile-content>
          <v-list-tile-title>{{ language.name }}</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          {{ language.code }}
        </v-list-tile-action>

      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import i18n from '@/plugins/i18n';
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      menu: false,
      languages: [
        {
          name: 'English',
          code: 'EN',
          value: 'en'
        },
        {
          name: 'Français',
          code: 'FR',
          value: 'fr'
        }
      ],
      selectedLanguage: {
        name: 'English',
        code: 'EN',
        value: 'en'
      }
    };
  },
  computed: {
    ...mapGetters([
      "getGeneralState"
    ]),
  },
  mounted() {
    this.selectedLanguage = this.languages.filter(el => el.value == this.getGeneralState('language'))[0]
    i18n.locale = this.selectedLanguage.value
  },
  methods: {
    ...mapMutations([
      "SET_LANGUAGE"
    ]),
    selectLanguage(language) {
      this.selectedLanguage = language;
      i18n.locale = language.value;
      this.SET_LANGUAGE(language.value)
      this.menu = false;
    }
  }
};
</script>

<style scoped>
.language--menu-color {
  background: var(--v-bg-base);
}

.lang-selector {
  display: flex;
  font-size: 18px;
  color: #BABABA;
  align-items: center;
  cursor: pointer;
  padding: 13px;
  font-weight: 500 !important;
}

.theme--light .lang-selector {
  color: #333333;
}

@media (max-width:510px) {
  .lang-selector {
    padding: 0;
  }
}
</style>
